export default {
    answer: 'Reply to post',
    read: 'Read comments',
    delete: 'Delete post',
    edit: 'Edit post'
}
